/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1680
 */

require(/* 86 */"./1650/86/index")({
  target: "Object",
  stat: true
}, {
  setPrototypeOf: require(/* 638 */"./1706/638")
})
